export default "__VITE_ASSET__17mZBPIB__"